import { render } from "./Idade.vue?vue&type=template&id=44a5295a"
import script from "./Idade.vue?vue&type=script&lang=js"
export * from "./Idade.vue?vue&type=script&lang=js"
script.render = render

export default script